import Action from '../Action/Action';

/*
  Appends a collection of new items created to state, with the option to undo if required.
*/
class CreateMultipleAction extends Action {
  constructor(setState, currentState, newItems) {
    super();
    this.setState = setState;
    this.currentState = currentState;
    this.newItems = newItems;
  }

  execute() {
    this.setState([...this.currentState, ...this.newItems]);
  }

  undo() {
    this.setState(this.currentState.filter(item => !this.newItems.find(i => i.id === item.id)));
  }
}

export default CreateMultipleAction;
